<template>
  <v-navigation-drawer
    id="app-drawer"
    v-model="inputValue"
    app
    dark
    floating
    persistent
    mobile-break-point="991"
    width="260"
  >
    <!-- <v-img
      :src="image"
      height="100%"
    > -->
      <v-layout
        class="fill-height"
        tag="v-list"
        column
      >
        <!-- <v-list-tile avatar>
          <v-list-tile-avatar
            color="white"
          >
            <v-img
              :src="profileImage"
            />
          </v-list-tile-avatar>
          <v-list-tile-title class="title">
            {{userProfile.GivenName}} {{userProfile.Surname}}
          </v-list-tile-title>
        </v-list-tile> -->
        <!-- <v-divider/> -->

        <v-list-tile avatar class="pt-3">
          <v-card-text class="text-xs-center pa-0">
            <v-avatar color="white" size="50">
              <v-img :src="profileImage"  style="border: 2px solid white"/>
            </v-avatar>
            <div class="pt-2 subheading">
              {{userProfile.GivenName}} {{userProfile.Surname}}
            </div>
          </v-card-text>
        </v-list-tile>

        <v-divider inset class="pa-0 mt-0 "/>

        <v-list-tile
          v-for="(link, i) in links"
          :key="i"
          :to="link.to"
          active-class="activeColor"
          avatar
          class="v-list-item"
        >
          <v-list-tile-action>
            <v-icon>{{ link.icon }}</v-icon>
          </v-list-tile-action>
          <v-list-tile-title
            class="font-weight-bold"
            v-text="link.text"
          />
        </v-list-tile>

        <div v-if="userProfile.IsAdmin">
          <v-list-tile
            v-for="(admin, j) in adminLinks"
            :key="`A-${j}`"
            :to="admin.to"
            active-class="pipefishOrange"
            avatar
            class="v-list-item"
          >
            <v-list-tile-action>
              <v-icon>{{ admin.icon }}</v-icon>
            </v-list-tile-action>
            <v-list-tile-title
              class="font-weight-bold"
              v-text="admin.text"
            />
          </v-list-tile>
        </div>

        <!-- class="v-list__tile--buy" -->
        <v-list-tile
          active-class="pipefishOrange"
          class="v-list-item"
          @click="$authService.logout()"
        >
          <v-list-tile-action>
            <v-icon>mdi-logout</v-icon>
          </v-list-tile-action>
          <v-list-tile-title class="font-weight-bold">
            Log out
          </v-list-tile-title>
        </v-list-tile>
      </v-layout>
    <!-- </v-img> -->
  </v-navigation-drawer>
</template>

<script>
// Utilities
import {
  mapMutations,
  mapState
} from 'vuex'

export default {
  data: () => ({
    name: "Pipefish",
    logo: '/img/pipefishLogo.png',
    links: [
      // {
      //   to: '/dashboard',
      //   icon: 'mdi-view-dashboard',
      //   text: 'Dashboard'
      // },
      {
        to: '/timesheets',
        icon: 'mdi-calendar-clock',
        text: 'My Timesheets'
      },
      {
        to: '/timesheetApproval',
        icon: 'mdi-alarm-check',
        text: 'Submission & Approvals'
      },
      // {
      //   to: '/submitTimesheets',
      //   icon: 'mdi-send',
      //   text: 'Submit Timesheets'
      // },
      {
        to: '/user-profile',
        icon: 'mdi-account-card-details-outline',
        text: 'My Profile'
      },
      {
        to: '/contacts',
        icon: 'mdi-account-multiple-outline',
        text: 'Pipefish Contacts'
      },
    ],
    adminLinks: [
      {
        to: '/admin',
        icon: 'mdi-shield-lock-outline',
        text: 'Admin'
      },
      {
        to: '/reports',
        icon: 'mdi-file-document-box-outline',
        text: 'Reports'
      }
    ],
    responsive: false
  }),
  computed: {
    ...mapState('app', ['image', 'color']),
    ...mapState('api', ['profileImage']),
    ...mapState('app', ['userProfile']),
    inputValue: {
      get () {
        return this.$store.state.app.drawer
      },
      set (val) {
        this.setDrawer(val)
      }
    },
    items () {
      return this.$t('Layout.View.items')
    }
  },
  mounted () {
    this.onResponsiveInverted()
    window.addEventListener('resize', this.onResponsiveInverted)
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.onResponsiveInverted)
  },
  methods: {
    ...mapMutations('app', ['setDrawer', 'toggleDrawer']),
    onResponsiveInverted () {
      if (window.innerWidth < 991) {
        this.responsive = true
      } else {
        this.responsive = false
      }
    }
  },
}
</script>

<style lang="scss">
  #app-drawer {
    .v-list__tile {
      border-radius: 4px;

      &--buy {
        margin-top: auto;
        margin-bottom: 17px;
      }
    }

    .v-image__image--contain {
      top: 9px;
      height: 60%;
    }

    .search-input {
      margin-bottom: 30px !important;
      padding-left: 15px;
      padding-right: 15px;
    }
  }
</style>
